import axios from "axios";
import Cookies from "js-cookie";
import stockimage from "../../img/stockbuilding.jpeg"

const GetImage = async (imgUri) => {
    try {
        // if image comes from skyspark server use authentication to fetch image
        if (imgUri.includes('infinity.skyspark')) {
            const headers = {
                "Authorization": "BEARER authToken=" + Cookies.get('skyarc-auth-8080')
            }
            const response = await axios.get(imgUri, {
                responseType: 'arraybuffer', // Important for browser
                headers
            });

            // Change image to base64 format
            const arrayBuffer = response.data;
            const uint8Array = new Uint8Array(arrayBuffer);
            const imageData = uint8Array.reduce((data, byte) => data + String.fromCharCode(byte), '');
    
            const base64ImageData = `data:${response.headers['content-type']};base64,${btoa(imageData)}`;

            return base64ImageData;
        } else return imgUri
    } catch {
        // If fetching uri fails return stockiamge
        return stockimage
    }
};

export default GetImage;
